import { motion, type MotionStyle } from "framer-motion";
import Divider from "./Divider";
import { twMerge } from "tailwind-merge";
import { BUN_PUBLIC_BLOB_BASE_URL } from "@/env.json";

export default function Navbar({ style, className }: { style?: MotionStyle; className?: string }) {
  return (
    <motion.div style={style} className={twMerge("navbar py-8 absolute top-0 z-50 px-4 md:px-8", className)}>
      <Divider className='mr-8 md:mr-16 hidden xs:block' />
      <div className='flex-none mx-auto'>
        <ul className='menu menu-horizontal p-0 flex gap-8 md:gap-15 align-middle text-sm md:text-base lg:text-lg'>
          <li>
            <a href='#work'>Work</a>
          </li>
          <li>
            <a href='#education'>Education</a>
          </li>
          <li>
            <a href={BUN_PUBLIC_BLOB_BASE_URL + "/Xavier_Teo_Resume_Portfolio_Ver.pdf"}>Resume</a>
          </li>
        </ul>
      </div>
      <Divider className='ml-8 md:ml-16 hidden xs:block' />
    </motion.div>
  );
}
